/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalServiceCreateReqVo,
  AdditionalServiceGroupCreateReqVo,
  AdditionalServiceGroupInfoSaveReqVo,
  AdditionalServiceGroupUpdateReqVo,
  AdditionalServiceUpdateReqVo,
  DisableAdditionalServiceReqVo,
  OrderTypeAdditionalServiceCreateReqVo,
  OrderTypeAdditionalServiceUpdateReqVo,
  ResponseAdditionalServiceGroupInfoRespVo,
  ResponseAdditionalServiceInfoRespVo,
  ResponseListAdditionalServiceGroupByWareIdRespVo,
  ResponseListAdditionalServiceGroupInfoRespVo,
  ResponseListGetAddiServByWareBillTypeRespVo,
  ResponseListGetAdditionGroupListByCreateOrderRespVo,
  ResponseLong,
  ResponseOrderTypeAdditionServiceRespVo,
  ResponsePageDataAdditionalServiceGroupInfoRespVo,
  ResponsePageDataAdditionalServicePageItemRespVo,
  ResponseString,
} from '../models/index';
import {
    AdditionalServiceCreateReqVoFromJSON,
    AdditionalServiceCreateReqVoToJSON,
    AdditionalServiceGroupCreateReqVoFromJSON,
    AdditionalServiceGroupCreateReqVoToJSON,
    AdditionalServiceGroupInfoSaveReqVoFromJSON,
    AdditionalServiceGroupInfoSaveReqVoToJSON,
    AdditionalServiceGroupUpdateReqVoFromJSON,
    AdditionalServiceGroupUpdateReqVoToJSON,
    AdditionalServiceUpdateReqVoFromJSON,
    AdditionalServiceUpdateReqVoToJSON,
    DisableAdditionalServiceReqVoFromJSON,
    DisableAdditionalServiceReqVoToJSON,
    OrderTypeAdditionalServiceCreateReqVoFromJSON,
    OrderTypeAdditionalServiceCreateReqVoToJSON,
    OrderTypeAdditionalServiceUpdateReqVoFromJSON,
    OrderTypeAdditionalServiceUpdateReqVoToJSON,
    ResponseAdditionalServiceGroupInfoRespVoFromJSON,
    ResponseAdditionalServiceGroupInfoRespVoToJSON,
    ResponseAdditionalServiceInfoRespVoFromJSON,
    ResponseAdditionalServiceInfoRespVoToJSON,
    ResponseListAdditionalServiceGroupByWareIdRespVoFromJSON,
    ResponseListAdditionalServiceGroupByWareIdRespVoToJSON,
    ResponseListAdditionalServiceGroupInfoRespVoFromJSON,
    ResponseListAdditionalServiceGroupInfoRespVoToJSON,
    ResponseListGetAddiServByWareBillTypeRespVoFromJSON,
    ResponseListGetAddiServByWareBillTypeRespVoToJSON,
    ResponseListGetAdditionGroupListByCreateOrderRespVoFromJSON,
    ResponseListGetAdditionGroupListByCreateOrderRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponseOrderTypeAdditionServiceRespVoFromJSON,
    ResponseOrderTypeAdditionServiceRespVoToJSON,
    ResponsePageDataAdditionalServiceGroupInfoRespVoFromJSON,
    ResponsePageDataAdditionalServiceGroupInfoRespVoToJSON,
    ResponsePageDataAdditionalServicePageItemRespVoFromJSON,
    ResponsePageDataAdditionalServicePageItemRespVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface AddServAddServicesWareIdBillTypeGetRequest {
    wareId: number;
    billType: number;
}

export interface AddServAvailableWareIdGetRequest {
    wareId: number;
    orderType?: number;
    transportMethodId?: number;
}

export interface AddServExportAdditionalServiceWarehouseIdGetRequest {
    warehouseId: number;
}

export interface AddServExportUploadTemplateTestGetRequest {
    warehouseId?: number;
}

export interface AddServGroupIdDeleteRequest {
    id: number;
}

export interface AddServGroupIdGetRequest {
    id: number;
}

export interface AddServGroupIdPutRequest {
    id: number;
    additionalServiceGroupUpdateReqVo?: AdditionalServiceGroupUpdateReqVo;
}

export interface AddServGroupInfosPostRequest {
    additionalServiceGroupInfoSaveReqVo?: AdditionalServiceGroupInfoSaveReqVo;
}

export interface AddServGroupInfosWareIdBillTypeGetRequest {
    wareId: number;
    billType: number;
}

export interface AddServGroupListGetRequest {
    warehouseId?: number;
}

export interface AddServGroupPageListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    warehouseId?: number;
    enable?: number;
    startTime?: string;
    endTime?: string;
}

export interface AddServGroupPostRequest {
    additionalServiceGroupCreateReqVo?: AdditionalServiceGroupCreateReqVo;
}

export interface AddServInfoDisablePutRequest {
    disableAdditionalServiceReqVo?: DisableAdditionalServiceReqVo;
}

export interface AddServInfoIdDeleteRequest {
    id: number;
}

export interface AddServInfoIdGetRequest {
    id: number;
}

export interface AddServInfoIdPutRequest {
    id: number;
    additionalServiceUpdateReqVo?: AdditionalServiceUpdateReqVo;
}

export interface AddServInfoPageListGetRequest {
    currentPage: number;
    pageSize: number;
    groupId?: number;
    keyword?: string;
    warehouseId?: number;
    currencyCode?: string;
    enable?: number;
    startTime?: string;
    endTime?: string;
    sortField?: string;
    sortOrder?: string;
}

export interface AddServInfoPostRequest {
    additionalServiceCreateReqVo?: AdditionalServiceCreateReqVo;
}

export interface AddServOrderTypeIdDeleteRequest {
    id: number;
}

export interface AddServOrderTypeIdGetRequest {
    id: number;
}

export interface AddServOrderTypeIdPutRequest {
    id: number;
    orderTypeAdditionalServiceUpdateReqVo?: OrderTypeAdditionalServiceUpdateReqVo;
}

export interface AddServOrderTypePostRequest {
    orderTypeAdditionalServiceCreateReqVo?: OrderTypeAdditionalServiceCreateReqVo;
}

export interface AddServOrderTypeTypeOrderTypeGetRequest {
    orderType: number;
}

export interface AddServUploadPostRequest {
    file: Blob;
    warehouseId: number;
}

/**
 * 
 */
export class AdditionServsControllerApi extends runtime.BaseAPI {

    /**
     * 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表 1.根据仓库编号,账单类型编号获取组列表 2.根据组列表,获取这些组下的全部附加服务列表 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表
     * 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表
     */
    async addServAddServicesWareIdBillTypeGetRaw(requestParameters: AddServAddServicesWareIdBillTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetAddiServByWareBillTypeRespVo>> {
        if (requestParameters['wareId'] == null) {
            throw new runtime.RequiredError(
                'wareId',
                'Required parameter "wareId" was null or undefined when calling addServAddServicesWareIdBillTypeGet().'
            );
        }

        if (requestParameters['billType'] == null) {
            throw new runtime.RequiredError(
                'billType',
                'Required parameter "billType" was null or undefined when calling addServAddServicesWareIdBillTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/add-services/{wareId}/{billType}`.replace(`{${"wareId"}}`, encodeURIComponent(String(requestParameters['wareId']))).replace(`{${"billType"}}`, encodeURIComponent(String(requestParameters['billType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetAddiServByWareBillTypeRespVoFromJSON(jsonValue));
    }

    /**
     * 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表 1.根据仓库编号,账单类型编号获取组列表 2.根据组列表,获取这些组下的全部附加服务列表 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表
     * 指定仓库编号,账单类型编号,获取对应组下的全部附加服务列表
     */
    async addServAddServicesWareIdBillTypeGet(requestParameters: AddServAddServicesWareIdBillTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetAddiServByWareBillTypeRespVo> {
        const response = await this.addServAddServicesWareIdBillTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端下单时,获取可选附加服务列表 客户端下单时,获取可选的附加服务列表
     * 客户端下单时,获取可选的附加服务列表
     */
    async addServAvailableWareIdGetRaw(requestParameters: AddServAvailableWareIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetAdditionGroupListByCreateOrderRespVo>> {
        if (requestParameters['wareId'] == null) {
            throw new runtime.RequiredError(
                'wareId',
                'Required parameter "wareId" was null or undefined when calling addServAvailableWareIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/available/{wareId}`.replace(`{${"wareId"}}`, encodeURIComponent(String(requestParameters['wareId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetAdditionGroupListByCreateOrderRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端下单时,获取可选附加服务列表 客户端下单时,获取可选的附加服务列表
     * 客户端下单时,获取可选的附加服务列表
     */
    async addServAvailableWareIdGet(requestParameters: AddServAvailableWareIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetAdditionGroupListByCreateOrderRespVo> {
        const response = await this.addServAvailableWareIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 按仓库id导出附加服务
     */
    async addServExportAdditionalServiceWarehouseIdGetRaw(requestParameters: AddServExportAdditionalServiceWarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling addServExportAdditionalServiceWarehouseIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/exportAdditionalService/{warehouseId}`.replace(`{${"warehouseId"}}`, encodeURIComponent(String(requestParameters['warehouseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 按仓库id导出附加服务
     */
    async addServExportAdditionalServiceWarehouseIdGet(requestParameters: AddServExportAdditionalServiceWarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.addServExportAdditionalServiceWarehouseIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 导出附加服务（按照批量上传模板格式）（测试接口） 测试接口：warehouseId不传时导出全部仓库，传入时仅导出指定仓库
     * 导出附加服务（按照批量上传模板格式）（测试接口）
     */
    async addServExportUploadTemplateTestGetRaw(requestParameters: AddServExportUploadTemplateTestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/export-upload-template-test`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 导出附加服务（按照批量上传模板格式）（测试接口） 测试接口：warehouseId不传时导出全部仓库，传入时仅导出指定仓库
     * 导出附加服务（按照批量上传模板格式）（测试接口）
     */
    async addServExportUploadTemplateTestGet(requestParameters: AddServExportUploadTemplateTestGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.addServExportUploadTemplateTestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 分组信息删除 分组信息删除
     * 分组信息删除
     */
    async addServGroupIdDeleteRaw(requestParameters: AddServGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServGroupIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 分组信息删除 分组信息删除
     * 分组信息删除
     */
    async addServGroupIdDelete(requestParameters: AddServGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServGroupIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定分组编号,获取附加服务组信息 指定分组编号,获取附加服务组信息
     * 指定分组编号,获取附加服务组信息
     */
    async addServGroupIdGetRaw(requestParameters: AddServGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdditionalServiceGroupInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServGroupIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdditionalServiceGroupInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定分组编号,获取附加服务组信息 指定分组编号,获取附加服务组信息
     * 指定分组编号,获取附加服务组信息
     */
    async addServGroupIdGet(requestParameters: AddServGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdditionalServiceGroupInfoRespVo> {
        const response = await this.addServGroupIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 附加服务组自信息修改 附加服务组信息修改 附加服务组自信息修改
     * 附加服务组信息修改
     */
    async addServGroupIdPutRaw(requestParameters: AddServGroupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServGroupIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalServiceGroupUpdateReqVoToJSON(requestParameters['additionalServiceGroupUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 附加服务组自信息修改 附加服务组信息修改 附加服务组自信息修改
     * 附加服务组信息修改
     */
    async addServGroupIdPut(requestParameters: AddServGroupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServGroupIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 账单类型的附加服务组数据保存 账单类型的附加服务组数据保存
     * 账单类型的附加服务组数据保存
     */
    async addServGroupInfosPostRaw(requestParameters: AddServGroupInfosPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group-infos`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalServiceGroupInfoSaveReqVoToJSON(requestParameters['additionalServiceGroupInfoSaveReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 账单类型的附加服务组数据保存 账单类型的附加服务组数据保存
     * 账单类型的附加服务组数据保存
     */
    async addServGroupInfosPost(requestParameters: AddServGroupInfosPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServGroupInfosPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定仓库编号,账单类型获取附加服务组信息列表 指定仓库编号,账单类型编号,获取附加服务组选择情况列表
     * 指定仓库编号,账单类型编号,获取附加服务组选择情况列表
     */
    async addServGroupInfosWareIdBillTypeGetRaw(requestParameters: AddServGroupInfosWareIdBillTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListAdditionalServiceGroupByWareIdRespVo>> {
        if (requestParameters['wareId'] == null) {
            throw new runtime.RequiredError(
                'wareId',
                'Required parameter "wareId" was null or undefined when calling addServGroupInfosWareIdBillTypeGet().'
            );
        }

        if (requestParameters['billType'] == null) {
            throw new runtime.RequiredError(
                'billType',
                'Required parameter "billType" was null or undefined when calling addServGroupInfosWareIdBillTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group-infos/{wareId}/{billType}`.replace(`{${"wareId"}}`, encodeURIComponent(String(requestParameters['wareId']))).replace(`{${"billType"}}`, encodeURIComponent(String(requestParameters['billType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListAdditionalServiceGroupByWareIdRespVoFromJSON(jsonValue));
    }

    /**
     * 指定仓库编号,账单类型获取附加服务组信息列表 指定仓库编号,账单类型编号,获取附加服务组选择情况列表
     * 指定仓库编号,账单类型编号,获取附加服务组选择情况列表
     */
    async addServGroupInfosWareIdBillTypeGet(requestParameters: AddServGroupInfosWareIdBillTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListAdditionalServiceGroupByWareIdRespVo> {
        const response = await this.addServGroupInfosWareIdBillTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 分组信息列表(不分页) 分组信息列表(不分页)
     * 分组信息列表(不分页)
     */
    async addServGroupListGetRaw(requestParameters: AddServGroupListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListAdditionalServiceGroupInfoRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListAdditionalServiceGroupInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 分组信息列表(不分页) 分组信息列表(不分页)
     * 分组信息列表(不分页)
     */
    async addServGroupListGet(requestParameters: AddServGroupListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListAdditionalServiceGroupInfoRespVo> {
        const response = await this.addServGroupListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 分组信息列表(分页) 分组信息列表(分页)
     * 分组信息列表(分页)
     */
    async addServGroupPageListGetRaw(requestParameters: AddServGroupPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdditionalServiceGroupInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling addServGroupPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling addServGroupPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdditionalServiceGroupInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 分组信息列表(分页) 分组信息列表(分页)
     * 分组信息列表(分页)
     */
    async addServGroupPageListGet(requestParameters: AddServGroupPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdditionalServiceGroupInfoRespVo> {
        const response = await this.addServGroupPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 附加服务组数据创建 附加服务组数据创建
     * 附加服务组数据创建
     */
    async addServGroupPostRaw(requestParameters: AddServGroupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalServiceGroupCreateReqVoToJSON(requestParameters['additionalServiceGroupCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 附加服务组数据创建 附加服务组数据创建
     * 附加服务组数据创建
     */
    async addServGroupPost(requestParameters: AddServGroupPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServGroupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量停用附加服务 批量停用附加服务
     * 批量停用附加服务
     */
    async addServInfoDisablePutRaw(requestParameters: AddServInfoDisablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info/disable`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DisableAdditionalServiceReqVoToJSON(requestParameters['disableAdditionalServiceReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 批量停用附加服务 批量停用附加服务
     * 批量停用附加服务
     */
    async addServInfoDisablePut(requestParameters: AddServInfoDisablePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.addServInfoDisablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,删除指定附加服务信息 指定编号,删除指定附加服务信息
     * 指定编号,删除指定附加服务信息
     */
    async addServInfoIdDeleteRaw(requestParameters: AddServInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServInfoIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定编号,删除指定附加服务信息 指定编号,删除指定附加服务信息
     * 指定编号,删除指定附加服务信息
     */
    async addServInfoIdDelete(requestParameters: AddServInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServInfoIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,获取附加服务信息 附加服务·详情
     * 附加服务·详情
     */
    async addServInfoIdGetRaw(requestParameters: AddServInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdditionalServiceInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServInfoIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdditionalServiceInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,获取附加服务信息 附加服务·详情
     * 附加服务·详情
     */
    async addServInfoIdGet(requestParameters: AddServInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdditionalServiceInfoRespVo> {
        const response = await this.addServInfoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取附加服务信息修改 获取附加服务信息修改
     * 获取附加服务信息修改
     */
    async addServInfoIdPutRaw(requestParameters: AddServInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServInfoIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalServiceUpdateReqVoToJSON(requestParameters['additionalServiceUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 获取附加服务信息修改 获取附加服务信息修改
     * 获取附加服务信息修改
     */
    async addServInfoIdPut(requestParameters: AddServInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServInfoIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取附加服务信息列表(分页) 附加服务·分页列表
     * 附加服务·分页列表
     */
    async addServInfoPageListGetRaw(requestParameters: AddServInfoPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdditionalServicePageItemRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling addServInfoPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling addServInfoPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['groupId'] != null) {
            queryParameters['groupId'] = requestParameters['groupId'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['currencyCode'] != null) {
            queryParameters['currencyCode'] = requestParameters['currencyCode'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdditionalServicePageItemRespVoFromJSON(jsonValue));
    }

    /**
     * 获取附加服务信息列表(分页) 附加服务·分页列表
     * 附加服务·分页列表
     */
    async addServInfoPageListGet(requestParameters: AddServInfoPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdditionalServicePageItemRespVo> {
        const response = await this.addServInfoPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取附加服务信息创建 获取附加服务信息创建
     * 获取附加服务信息创建
     */
    async addServInfoPostRaw(requestParameters: AddServInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalServiceCreateReqVoToJSON(requestParameters['additionalServiceCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 获取附加服务信息创建 获取附加服务信息创建
     * 获取附加服务信息创建
     */
    async addServInfoPost(requestParameters: AddServInfoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单类型的附加服务组和必选附加服务-删除 订单类型的附加服务组和必选附加服务-删除
     * 订单类型的附加服务组和必选附加服务-删除
     */
    async addServOrderTypeIdDeleteRaw(requestParameters: AddServOrderTypeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServOrderTypeIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/order-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 订单类型的附加服务组和必选附加服务-删除 订单类型的附加服务组和必选附加服务-删除
     * 订单类型的附加服务组和必选附加服务-删除
     */
    async addServOrderTypeIdDelete(requestParameters: AddServOrderTypeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServOrderTypeIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单类型的附加服务组和必选附加服务-指定数据编号获取 订单类型的附加服务组和必选附加服务-指定数据编号获取
     * 订单类型的附加服务组和必选附加服务-指定数据编号获取
     */
    async addServOrderTypeIdGetRaw(requestParameters: AddServOrderTypeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderTypeAdditionServiceRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServOrderTypeIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/order-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderTypeAdditionServiceRespVoFromJSON(jsonValue));
    }

    /**
     * 订单类型的附加服务组和必选附加服务-指定数据编号获取 订单类型的附加服务组和必选附加服务-指定数据编号获取
     * 订单类型的附加服务组和必选附加服务-指定数据编号获取
     */
    async addServOrderTypeIdGet(requestParameters: AddServOrderTypeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderTypeAdditionServiceRespVo> {
        const response = await this.addServOrderTypeIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单类型的附加服务组和必选附加服务-修改 订单类型的附加服务组和必选附加服务-修改
     * 订单类型的附加服务组和必选附加服务-修改
     */
    async addServOrderTypeIdPutRaw(requestParameters: AddServOrderTypeIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServOrderTypeIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/order-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderTypeAdditionalServiceUpdateReqVoToJSON(requestParameters['orderTypeAdditionalServiceUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 订单类型的附加服务组和必选附加服务-修改 订单类型的附加服务组和必选附加服务-修改
     * 订单类型的附加服务组和必选附加服务-修改
     */
    async addServOrderTypeIdPut(requestParameters: AddServOrderTypeIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServOrderTypeIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单类型的附加服务组和必选附加服务-创建 订单类型的附加服务组和必选附加服务-创建
     * 订单类型的附加服务组和必选附加服务-创建
     */
    async addServOrderTypePostRaw(requestParameters: AddServOrderTypePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/order-type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderTypeAdditionalServiceCreateReqVoToJSON(requestParameters['orderTypeAdditionalServiceCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 订单类型的附加服务组和必选附加服务-创建 订单类型的附加服务组和必选附加服务-创建
     * 订单类型的附加服务组和必选附加服务-创建
     */
    async addServOrderTypePost(requestParameters: AddServOrderTypePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.addServOrderTypePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单类型的附加服务组和必选附加服务-指定order_type获取 订单类型的附加服务组和必选附加服务-指定order_type获取
     * 订单类型的附加服务组和必选附加服务-指定order_type获取
     */
    async addServOrderTypeTypeOrderTypeGetRaw(requestParameters: AddServOrderTypeTypeOrderTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderTypeAdditionServiceRespVo>> {
        if (requestParameters['orderType'] == null) {
            throw new runtime.RequiredError(
                'orderType',
                'Required parameter "orderType" was null or undefined when calling addServOrderTypeTypeOrderTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/add-serv/order-type/type/{orderType}`.replace(`{${"orderType"}}`, encodeURIComponent(String(requestParameters['orderType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderTypeAdditionServiceRespVoFromJSON(jsonValue));
    }

    /**
     * 订单类型的附加服务组和必选附加服务-指定order_type获取 订单类型的附加服务组和必选附加服务-指定order_type获取
     * 订单类型的附加服务组和必选附加服务-指定order_type获取
     */
    async addServOrderTypeTypeOrderTypeGet(requestParameters: AddServOrderTypeTypeOrderTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderTypeAdditionServiceRespVo> {
        const response = await this.addServOrderTypeTypeOrderTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 附加服务批量上传 附加服务批量上传
     * 附加服务批量上传
     */
    async addServUploadPostRaw(requestParameters: AddServUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling addServUploadPost().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling addServUploadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['warehouseId'] != null) {
            formParams.append('warehouseId', requestParameters['warehouseId'] as any);
        }

        const response = await this.request({
            path: `/add-serv/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 附加服务批量上传 附加服务批量上传
     * 附加服务批量上传
     */
    async addServUploadPost(requestParameters: AddServUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.addServUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
